import { getUserInfo } from '@/features/auth/client';
import { isOnlyMvpdAuthenticated } from '@/features/auth/client/isOnlyMvpdAuthenticated';

export function computeEventServiceAccountId(): string {
  const { accountType, profileId } = getUserInfo();
  const isAnonymous = accountType === 'anonymous';
  const mvpdOnly = isOnlyMvpdAuthenticated();

  return !isAnonymous && !mvpdOnly && profileId ? profileId : '';
}
